import { DataroomTenant } from '@/dataroom/domain/vo/types/DataroomTenant';
import { Area } from '@/dataroom/domain/vo/Area';
import DataroomTenantConfig from '@/dataroom/application/config/DataroomTenantConfig';

export const getAreaTitles = (tenant: DataroomTenant) => ({
  [Area.Primary]: DataroomTenantConfig.fromCode(tenant).options.tenantLabel,
  [Area.Staging]: 'Staging Area',
});
